import { jsx } from "panel";
import { ModalEl, ModalType } from "common/components/modal";
import { FEATURES } from "./util";
import iconReportGeneric from "./icon-report-generic.svg";
import iconCustomEvents from "./icon-custom-events.svg";
import iconCSV from "./icon-csv.svg";
import iconBookmarks from "./icon-bookmarks.svg";
export function template() {
  const feature = this.attr("feature");
  return /* @__PURE__ */ jsx(ModalEl, { attrs: {
    "modal-type": ModalType.Popup,
    closeable: true,
    "not-fullscreen": true,
    open: this.attr("open")
  }, on: {
    change: this.helpers.handleModalChange
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-upsell-popup-content" }, /* @__PURE__ */ jsx("div", { sel: ".mp-upsell-popup-icon" }, /* @__PURE__ */ jsx(Icon, { feature, "data-sentry-element": "Icon", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".mp-upsell-popup-text" }, /* @__PURE__ */ jsx(Text, { feature, "data-sentry-element": "Text", "data-sentry-source-file": "template.tsx" }))));
}
function Icon(props) {
  let src = iconReportGeneric;
  switch (props.feature) {
    case FEATURES.CUSTOM_EVENTS:
      src = iconCustomEvents;
      break;
    case FEATURES.EXPORT_CSV:
      src = iconCSV;
      break;
    case FEATURES.BOOKMARK_MAXIMUM:
      src = iconBookmarks;
      break;
  }
  return /* @__PURE__ */ jsx("img", { src, "data-sentry-component": "Icon", "data-sentry-source-file": "template.tsx" });
}
function Text(props) {
  switch (props.feature) {
    case FEATURES.CUSTOM_EVENTS:
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(UpgradeLink, null, "Upgrade"), " your plan to create more custom events.");
    case FEATURES.DATE_RANGE:
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(UpgradeLink, null, "Upgrade"), " your plan to query a wider date range.");
    case FEATURES.EXPORT_CSV:
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(UpgradeLink, null, "Upgrade"), " your plan to export a CSV report.");
    case FEATURES.FILTER_LEVELS:
      return /* @__PURE__ */ jsx(null, null, "More filters are not available. ", /* @__PURE__ */ jsx(UpgradeLink, null, "Upgrade"), " your plan for more.");
    case FEATURES.BOOKMARK_MAXIMUM:
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(UpgradeLink, { href: "/pricing/?utm_source=bookmark_limit_gate" }, "Upgrade"), " your plan to save more bookmarks.");
    default:
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(UpgradeLink, null, "Upgrade"), " your plan to do more.");
  }
}
function UpgradeLink(_ref, children) {
  let {
    href = "/pricing/"
  } = _ref;
  return /* @__PURE__ */ jsx("a", { sel: ".upgrade-link", href, target: "_blank", "data-sentry-component": "UpgradeLink", "data-sentry-source-file": "template.tsx" }, children);
}
